export const PageContentAtom = ({
  children
}: {
  children: React.ReactNode
}) => {
  return (
    <div className="flex flex-grow p-4 flex-col overflow-auto gap-4">
      {children}
    </div>
  )
}
